import {
  BusinessChart,
  IndustryChart,
} from "app/components/static-charts/who-we-serve";
import { getLangDir, isRtlLang } from "app/hooks/rtl-detect";
import { useI18nLanguage } from "app/hooks/i18n";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const ChartSwiper = () => {
  const { t: trans } = useTranslation();
  const swiperRef = useRef(null);
  const { locale: language } = useI18nLanguage();

  useEffect(() => {
    const swiperContainer = swiperRef.current;

    const params = {
      dir: getLangDir(language),
      initialSlide: 0,
      loop: false,
      breakpoints: {
        1280: {
          spaceBetween: 0,
          slidesPerView: 2,
          allowTouchMove: false,
          centeredSlides: false,
        },
        1024: {
          spaceBetween: 0,
          slidesPerView: 2,
          allowTouchMove: false,
          centeredSlides: false,
        },
        768: {
          spaceBetween: 0,
          slidesPerView: 2,
          allowTouchMove: true,
          centeredSlides: true,
        },
        320: {
          slidesPerView: 2,
          allowTouchMove: true,
          centeredSlides: true,
        },
      },
    };
    Object.assign(swiperContainer, params);
    swiperContainer.initialize();
    swiperContainer.swiper.rtl = isRtlLang(language);
    swiperContainer.swiper.rtlTranslate = isRtlLang(language);
  }, [language]);

  const businessChartText = trans("Type of Business");
  const industryChartText = trans("By Industry");

  return (
    <div className="who-we-serve-swiper h-full w-full lg:w-[99%] xl:max-w-[800px] lg:mx-auto">
      <swiper-container
        ref={swiperRef}
        init="false"
        key={`charts-${language}-swiper`}
      >
        <swiper-slide>
          <div className="mt-8 xl:mt-0">
            <IndustryChart innerText={industryChartText} />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div className="mt-8 xl:mt-0">
            <BusinessChart innerText={businessChartText} />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  );
};
